export var tableCellLabelDefaultTheme = {
  Root: {
    base: {
      fontFamily: '$typography.body.fontFamily'
    }
  }
};